import { Center, Text } from '@chakra-ui/react';
import { Modal } from '@diamond/shared/ui';

interface HighlightDeleteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

export function HighlightDeleteModal({
  isOpen,
  onClose,
  onSubmit,
}: HighlightDeleteModalProps) {
  if (!isOpen) {
    return null;
  }

  return (
    <Modal
      name="delete-highlight"
      isOpen={isOpen}
      labelCancel="Kembali"
      labelSubmit="Hapus"
      buttonColor="red"
      onClose={onClose}
      onSubmit={onSubmit}
      isCentered
    >
      <Center>
        <Text fontSize="2xl" as="b">
          Hapus Highlight?
        </Text>
      </Center>
    </Modal>
  );
}
